import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./listMeetings.css";
import CategoriesDropdown from "./categoriesDropdown";
import MeetingsCalendar from "./meetingsCalender";
import SmallCalendar from "./smallCalendar";
import { useDispatch, useSelector } from "react-redux";
import { getMeetingList } from "../../Redux/Actions/meetingAction";
import axios from "axios";
import toast from "react-hot-toast";
import { viewTeamMembersListNoPagination } from "../../Redux/Actions/teamMembersAction";
import { getEnums } from "../../Redux/Actions/enumsActions";

const ListMeetings = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [isOpen, setIsOpen] = useState(false);
  const [eventsProp, setEventsProp] = useState([]);
  const categories = ["Team Meeting", "Customer Meeting", "Re-Scheduled"];
  const myMeetings = ["Scheduled", "Re-Scheduled", "Cancel"];
  const label = "My Meetings";

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 1000,
    total: 0,
  });

  const dispatch = useDispatch();

  const fetchDetails = (page, limit) => {
    dispatch(getMeetingList({ page, limit }));
    dispatch(viewTeamMembersListNoPagination({ role: "business_manager" }));
  };

  useEffect(() => {
    dispatch(getEnums());
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { meetings } = useSelector((state) => state.meetings || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { teamMembers } = useSelector((state) => state.teamMembers);

  useEffect(() => {
    if (meetings?.total) {
      setPagination((prev) => ({ ...prev, total: meetings.total }));
    }
  }, [meetings]);

  const [selectedMeeting, setSelectedMeeting] = useState({});

  const meetingStatus = enumsData?.data?.meetingStatus
    ? Object.values(enumsData.data.meetingStatus).map((v) => v)
    : [];

  const [meetingApiPayload, setMeetingApiPayload] = useState({
    meeting_id: "",
    meeting_link: "",
    business_manager: "",
    status: "",
    time: "",
  });

  const addMeetingPopupHandler = () => {
    setIsOpen(!isOpen);
  };

  const parseTime = (timeStr) => {
    const time = timeStr.slice(0, 5);
    const modifier = timeStr.slice(5).toUpperCase();
    let [hours, minutes] = time.split(":").map(Number);
    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;
    return { hours, minutes };
  };

  const formatEventStart = (dateStr, timeStr) => {
    const date = new Date(dateStr);
    if (!timeStr) return date;
    const { hours, minutes } = parseTime(timeStr);
    date.setHours(hours, minutes, 0, 0);
    return date;
  };

  useEffect(() => {
    const formattedEvents = meetings?.data?.data?.map((meeting) => ({
      title:
        meeting.purpose_for_meeting.charAt(0).toUpperCase() +
        meeting.purpose_for_meeting.slice(1) || "Meeting",
      id: meeting._id,
      link: meeting.meeting_link || "Add Link",
      start: formatEventStart(meeting.meeting_date, meeting.time),
      end: meeting.endDate
        ? new Date(meeting.endDate)
        : new Date(
          formatEventStart(meeting.meeting_date, meeting.time).getTime() +
          60 * 30 * 1000
        ),
      time: meeting.time,
    }));
    setEventsProp(formattedEvents);
  }, [meetings]);

  const clickedMeeting = (event) => {
    try {
      const meetingId = event.id;
      if (meetingId) {
        const found = Array.isArray(meetings?.data?.data)
          ? meetings.data.data.find((m) => m._id === meetingId)
          : null;
        if (!found) return;

        setSelectedMeeting(found);
        setMeetingApiPayload({
          meeting_id: found._id,
          meeting_link: found.meeting_link || "",
          business_manager: found.business_manager?._id || found.business_manager || "",
          status: found.status || "",
          time: found.time || "",
        });
        addMeetingPopupHandler();
      }
    } catch (err) {
      console.error("Meeting Not Found");
    }
  };

  const addMeetingLinkHandler = async () => {
    if (!meetingApiPayload.business_manager) {
      toast.error("Please assign a Business Manager!");
      return;
    }
    if (!meetingApiPayload.meeting_link) {
      toast.error("Please provide a Meeting Link!");
      return;
    }

    try {
      const nonEmptyPayload = Object.fromEntries(
        Object.entries(meetingApiPayload).filter(
          ([_, v]) => v !== "" && v !== null && v !== undefined
        )
      );

      await axios.post(`${BASE_URL}/meeting/update`, nonEmptyPayload, {
        headers: { "Content-Type": "application/json" },
      });
      toast.success("Meeting updated successfully");
      setIsOpen(false);
      fetchDetails(pagination.current, pagination.pageSize);
    } catch (error) {
      console.error("Error while updating meeting", error);
      toast.error("Failed to update meeting");
    }
  };

  const clearBusinessManager = () => {
    setMeetingApiPayload((prev) => ({ ...prev, business_manager: "" }));
  };

  const formatDate = (dateStr) =>
    dateStr ? new Date(dateStr).toLocaleDateString() : "No data";

  return (
    <MainLayout>
      <div style={{ display: "flex", gap: "16px", padding: "0 10px", width: "100%" }}>

        <div
          className="mtg-calendar-container"
          style={{
            flex: 1,
            minWidth: 0,
            background: "white",
            borderRadius: "25px",
          }}
        >
          <MeetingsCalendar onSelectEvent={clickedMeeting} events={eventsProp} />
        </div>

        <div style={{ width: "280px", flexShrink: 0 }}>
          <SmallCalendar />
          <CategoriesDropdown label={label} categories={myMeetings} />
          <CategoriesDropdown
            label="Categories"
            categories={categories}
            showColorSquares={true}
          />
        </div>

      </div>

      {isOpen && (
        <div className="mtg-overlay-backdrop">
          <div className="mtg-modal-content">

            {/* ── Header ── */}
            <div className="mtg-modal-header">
              <div className="mtg-modal-header-left">
                <div className="mtg-header-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="3" />
                    <path d="M16 2v4M8 2v4M3 10h18" />
                  </svg>
                </div>
                <div>
                  <span className="mtg-modal-title">Update Meeting</span>
                  <p className="mtg-modal-subtitle">
                    {formatDate(selectedMeeting?.meeting_date)}
                    {selectedMeeting?.time && ` · ${selectedMeeting.time}`}
                    {selectedMeeting?.slot && ` · ${selectedMeeting.slot} slot`}
                  </p>
                </div>
              </div>
              <button className="mtg-close-btn" onClick={addMeetingPopupHandler}>✕</button>
            </div>

            {/* ── Body ── */}
            <div className="mtg-modal-body">

              {/* Meeting Link */}
              <p className="mtg-section-label">Meeting Link</p>
              <div className="mtg-link-wrap">
                <input
                  type="text"
                  className="mtg-input-field mtg-editable"
                  placeholder="Paste meeting URL here…"
                  value={meetingApiPayload.meeting_link}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.trim() === "") toast.error("Meeting link cannot be empty");
                    setMeetingApiPayload((prev) => ({ ...prev, meeting_link: value }));
                  }}
                />
                <svg className="mtg-link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" />
                  <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" />
                </svg>
              </div>

              <div className="mtg-divider" />

              {/* Builder */}
              <p className="mtg-section-label">Builder</p>
              <div className="mtg-grid-2">
                <div className="mtg-field">
                  <span className="mtg-label">Name</span>
                  <input className="mtg-input-field" type="text" disabled
                    value={selectedMeeting?.builder?.brand_name || "No data"} />
                </div>
                <div className="mtg-field">
                  <span className="mtg-label">Email</span>
                  <input className="mtg-input-field" type="text" disabled
                    value={selectedMeeting?.builder?.primary_email || "No data"} />
                </div>
              </div>

              <div className="mtg-divider" />

              {/* User */}
              <p className="mtg-section-label">User</p>
              <div className="mtg-grid-2">
                <div className="mtg-field">
                  <span className="mtg-label">Name</span>
                  <input className="mtg-input-field" type="text" disabled
                    value={selectedMeeting?.user?.name || "No data"} />
                </div>
                <div className="mtg-field">
                  <span className="mtg-label">Email</span>
                  <input className="mtg-input-field" type="text" disabled
                    value={selectedMeeting?.user?.email || "No data"} />
                </div>
                <div className="mtg-field">
                  <span className="mtg-label">Country Code</span>
                  <input className="mtg-input-field" type="text" disabled
                    value={selectedMeeting?.user?.country_code || "No data"} />
                </div>
                <div className="mtg-field">
                  <span className="mtg-label">Contact Number</span>
                  <input className="mtg-input-field" type="text" disabled
                    value={selectedMeeting?.user?.contact_number || "No data"} />
                </div>
              </div>

              <div className="mtg-divider" />

              {/* Meeting Details */}
              <p className="mtg-section-label">Meeting Details</p>
              <div className="mtg-grid-2">
                <div className="mtg-field">
                  <span className="mtg-label">Purpose</span>
                  <input className="mtg-input-field" type="text" disabled
                    value={selectedMeeting?.purpose_for_meeting || "No data"} />
                </div>
                <div className="mtg-field">
                  <span className="mtg-label">Note</span>
                  <input className="mtg-input-field" type="text" disabled
                    value={selectedMeeting?.note || "No data"} />
                </div>
                <div className="mtg-field">
                  <span className="mtg-label">Guests</span>
                  <input className="mtg-input-field" type="text" disabled
                    value={
                      selectedMeeting?.guests?.length > 0
                        ? selectedMeeting.guests.map((g) => g.email).join(", ")
                        : "No data"
                    }
                  />
                </div>

                {/* Project or Property */}
                {selectedMeeting?.project ? (
                  <>
                    <div className="mtg-field">
                      <span className="mtg-label">Project Name</span>
                      <input className="mtg-input-field" type="text" disabled
                        value={selectedMeeting.project?.project_name || "No data"} />
                    </div>
                    <div className="mtg-field">
                      <span className="mtg-label">Project ID</span>
                      <input className="mtg-input-field" type="text" disabled
                        value={selectedMeeting.project?.project_id || "No data"} />
                    </div>
                    <div className="mtg-field">
                      <span className="mtg-label">Business Type</span>
                      <input className="mtg-input-field" type="text" disabled
                        value={selectedMeeting.business_type || "No data"} />
                    </div>
                  </>
                ) : selectedMeeting?.property ? (
                  <>
                    <div className="mtg-field">
                      <span className="mtg-label">Property ID</span>
                      <input className="mtg-input-field" type="text" disabled
                        value={selectedMeeting.property?.property_id || "No data"} />
                    </div>
                    <div className="mtg-field">
                      <span className="mtg-label">Business Type</span>
                      <input className="mtg-input-field" type="text" disabled
                        value={selectedMeeting.property?.business_type || "No data"} />
                    </div>
                    <div className="mtg-field">
                      <span className="mtg-label">Property Type</span>
                      <input className="mtg-input-field" type="text" disabled
                        value={selectedMeeting.property?.project_type || "No data"} />
                    </div>
                    <div className="mtg-field">
                      <span className="mtg-label">Property Location</span>
                      <input className="mtg-input-field" type="text" disabled
                        value={selectedMeeting.property?.street_address || "No data"} />
                    </div>
                  </>
                ) : (
                  <div className="mtg-field">
                    <span className="mtg-label">Project / Property</span>
                    <input className="mtg-input-field" type="text" disabled value="No data" />
                  </div>
                )}

                <div className="mtg-field">
                  <span className="mtg-label">Date</span>
                  <input className="mtg-input-field" type="text" disabled
                    value={formatDate(selectedMeeting?.meeting_date)} />
                </div>
                <div className="mtg-field">
                  <span className="mtg-label">Slot</span>
                  <input className="mtg-input-field" type="text" disabled
                    value={selectedMeeting?.slot || "No data"} />
                </div>

                {/* Time — editable only when rescheduled */}
                <div className="mtg-field">
                  <span className="mtg-label">Meeting Time</span>
                  {meetingApiPayload?.status === "rescheduled" ? (
                    <input
                      type="time"
                      className="mtg-input-field mtg-editable"
                      value={meetingApiPayload.time}
                      onChange={(e) =>
                        setMeetingApiPayload((prev) => ({ ...prev, time: e.target.value }))
                      }
                    />
                  ) : (
                    <input className="mtg-input-field" type="text" disabled
                      value={selectedMeeting?.time || "No data"} />
                  )}
                </div>

                {/* Status */}
                <div className="mtg-field">
                  <span className="mtg-label">Meeting Status</span>
                  <select
                    className="mtg-input-field mtg-editable mtg-select"
                    value={meetingApiPayload.status}
                    onChange={(e) =>
                      setMeetingApiPayload((prev) => ({ ...prev, status: e.target.value }))
                    }
                  >
                    <option disabled value="">Select status</option>
                    {Array.isArray(meetingStatus) &&
                      meetingStatus.map((item, idx) => (
                        <option value={item} key={idx}>
                          {item.charAt(0).toUpperCase() + item.slice(1)}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="mtg-divider" />

              {/* Business Manager */}
              <p className="mtg-section-label">Business Manager</p>
              <div className="mtg-manager-row">
                {meetingApiPayload.business_manager ? (
                  <input
                    type="text"
                    className="mtg-input-field mtg-editable"
                    readOnly
                    value={
                      Array.isArray(teamMembers?.data)
                        ? teamMembers.data.find(
                          (m) => m._id === meetingApiPayload.business_manager
                        )?.name || selectedMeeting?.business_manager?.name || ""
                        : selectedMeeting?.business_manager?.name || ""
                    }
                  />
                ) : (
                  <select
                    className="mtg-input-field mtg-editable mtg-select"
                    value={meetingApiPayload.business_manager}
                    onChange={(e) =>
                      setMeetingApiPayload((prev) => ({
                        ...prev,
                        business_manager: e.target.value,
                      }))
                    }
                  >
                    <option disabled value="">Assign a manager…</option>
                    {Array.isArray(teamMembers?.data) &&
                      teamMembers.data.map((member) => (
                        <option key={member._id} value={member._id}>
                          {member.name}
                        </option>
                      ))}
                  </select>
                )}
                {meetingApiPayload.business_manager && (
                  <button className="mtg-clear-btn" onClick={clearBusinessManager} title="Clear">✕</button>
                )}
              </div>

            </div>

            {/* ── Footer ── */}
            <div className="mtg-modal-footer">
              <button className="mtg-btn mtg-btn-cancel" onClick={addMeetingPopupHandler}>
                Cancel
              </button>
              <button className="mtg-btn mtg-btn-primary" onClick={addMeetingLinkHandler}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
                Save Changes
              </button>
            </div>

          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default ListMeetings;